import { useEffect, useRef } from 'react';
import axios from 'axios';
import { getPersonProfileShortInfoRoute } from '../routes/persons';
import { useAppDispatch } from '../../store/hooks';
import { setInfoEmailConfirm } from '../../store/slices/personsSlice/personsSlice';

const POLL_INTERVAL = 5000; // 5 секунд
const MAX_DURATION = 15 * 60 * 1000; // 15 минут
const LOCAL_STORAGE_KEY = 'emailConfirmationStart';

export function useEmailConfirmationPolling() {
  const pollIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const dispatch = useAppDispatch();

  const stopPolling = () => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  };

  const shouldContinuePolling = () => {
    const startTime = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!startTime) return false;
    const elapsed = Date.now() - parseInt(startTime, 10);
    return elapsed < MAX_DURATION;
  };

  const poll = async () => {
    if (!shouldContinuePolling()) {
      stopPolling();
      return;
    }

    const response = axios.get(getPersonProfileShortInfoRoute());
    const { data } = await response;
    if (data?.emailConfirmation) {
      stopPolling();
      dispatch(setInfoEmailConfirm(true));
    }
  };

  const startPolling = () => {
    // Установить стартовое время, если ещё не установлено
    if (!localStorage.getItem(LOCAL_STORAGE_KEY)) {
      localStorage.setItem(LOCAL_STORAGE_KEY, Date.now().toString());
    }

    poll(); // Первый запуск
    pollIntervalRef.current = setInterval(poll, POLL_INTERVAL);
  };

  useEffect(() => {
    if (shouldContinuePolling()) {
      startPolling();
    }

    return () => {
      stopPolling();
    };
  }, []);

  return {
    startPolling,
    stopPolling,
  };
}
